// extracted by mini-css-extract-plugin
module.exports = {"borderArea":"_1RxuC","borderAreaHover":"_2VOUp"};